// Deprecated: To use PRODUCT_NAMES insetad
export const productNames = {
  CONSUMER_DEBIT_CARD: 'CONSUMER_DEBIT_CARD',
  BUSINESS_DEBIT_CARD: 'BUSINESS_DEBIT_CARD',
  BUSINESS_DEBIT_CARD_ADDITIONAL: 'BUSINESS_DEBIT_CARD_ADDITIONAL',
  CONSUMER_DEBIT_CARD_LEGACY: 'CONSUMER_DEBIT_CARD_LEGACY',
  CONSUMER_VIRTUAL_DEBIT_CARD: 'CONSUMER_VIRTUAL_DEBIT_CARD',
  SAMSUNGPAY: 'SAMSUNGPAY',
  GOOGLEPAY: 'GOOGLEPAY',
  FULL_WALLET_CARD: 'FULL_WALLET_CARD',
}

export const ISSUANCE_PRODUCT_NAMES = {
  CONSUMER_DD_DEBIT_MASTERCARD_EMV_US: 'CONSUMER_DD_DEBIT_MASTERCARD_EMV_US',
  CONSUMER_DEBIT_MC_CARD_DE: 'CONSUMER_DEBIT_MC_CARD_DE',
  CONSUMER_DEBIT_MC_CARD_GB: 'CONSUMER_DEBIT_MC_CARD_GB'
}

export const PRODUCT_NAMES = productNames

// TODO merge into PRODUCT_NAMES above
// productName - Used in URL path param
export const PRODUCT_NAME_VARIATIONS = {
  vc: {
    nickname: 'vc',
    system: productNames.CONSUMER_VIRTUAL_DEBIT_CARD,
    userFriendly: 'virtual-card',
    shortProductName: 'key',
  },
  fwc: {
    system: productNames.FULL_WALLET_CARD,
    userFriendly: 'fwc',
    alias: 'fwc',
  },
  ppdc: {
    system: productNames.CONSUMER_DEBIT_CARD,
    alias: 'ppdc',
    userFriendly: 'paypal-debit-card',
    supportedCountries: ['us'],
    fallbackCountryCode: 'us',
  },
  bdmc: {
    system: PRODUCT_NAMES.BUSINESS_DEBIT_CARD,
    userFriendly: 'business-debit-card',
    alias: 'bdmc',
  },
}

function getProductNameVariationsObject(productNameUserFriendlyOrSystem) {
  return Object.values(PRODUCT_NAME_VARIATIONS).find((p) =>
    [p.userFriendly, p.system].includes(productNameUserFriendlyOrSystem),
  )
}

const getProductName = (nameType) => (productNameUserFriendlyOrSystem) => {
  const productNameVariationsObject = getProductNameVariationsObject(
    productNameUserFriendlyOrSystem,
  )
  return productNameVariationsObject && productNameVariationsObject[nameType]
}

export function getProductAlias(name) {
  return getProductName('alias')(name)
}

export function getProductUserFriendlyName(name) {
  return getProductName('userFriendly')(name)
}

export function getProductSystemName(name) {
  return getProductName('system')(name)
}

export function getSupportedCountryCodeByProductName(productName, currentCountry) {
  const { supportedCountries, fallbackCountryCode } = getProductNameVariationsObject(productName)
  if (supportedCountries.includes(currentCountry)) {
    return currentCountry
  }
  return fallbackCountryCode
}

export const FUNDING_TYPES = {
  ATU: {
    AUTO_RELOAD: 'AUTO_RELOAD',
    AUTO_RELOAD_PER_CARD: 'AUTO_RELOAD_PER_CARD',
    AUTO_RELOAD_EXACT_PER_CARD: 'AUTO_RELOAD_EXACT_PER_CARD',
  },
  BUFS: {
    DIRECT_FUNDING: 'DIRECT_FUNDING',
    DIRECT_FUNDING_PER_CARD: 'DIRECT_FUNDING_PER_CARD',
  },
}

export const FUNDING_TYPE_SHORT_NAMES = {
  ATU: 'topup',
  BUFS: 'bufs',
}

export const getFundingShortName = (type) => {
  const ATU = Object.values(FUNDING_TYPES.ATU)
  const BUFS = Object.values(FUNDING_TYPES.BUFS)

  if (ATU.includes(type)) return FUNDING_TYPE_SHORT_NAMES.ATU
  else if (BUFS.includes(type)) return FUNDING_TYPE_SHORT_NAMES.BUFS
  return ''
}

// Deprecated: To use APPLICATION_STATUS
export const applicationStatus = {
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
  NEED_MORE_DATA: 'NEED_MORE_DATA',
  STEPUP_AUTH: 'STEPUP_AUTH',
}

export const APPLICATION_STATUS = applicationStatus

export const NEED_MORE_DATA_CODES = {
  NEED_MORE_INFO: 'NEED_MORE_INFO',
  IDENTITY_VERIFICATION_REQUIRED: 'IDENTITY_VERIFICATION_REQUIRED',
}

export const NEED_MORE_INFO_VALUES = {
  CFPB_LEGAL_LOGGING: 'CFPB_LEGAL_LOGGING',
  SSN: 'SSN',
  SHIPPING_ADDRESS: 'SHIPPING_ADDRESS',
  PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
  UTILITIES_BILL: 'UTILITIES_BILL',
}

export const CARD_LIFECYCLE_STATE = {
  ACTIVE: 'ACTIVE',
  PENDING_ACTIVE: 'PENDING_ACTIVE',
  REISSUED: 'REISSUED',
  DEACTIVATED: 'DEACTIVATED',
  CLOSED: 'CLOSED',
}

export const DEACTIVATED_REASON = {
  BLOCKED: 'BLOCKED',
  USER: 'USER,',
}

/**
 * possible values of cfscardlifecycleserv's card.operation_metadata[x].name
 */
export const CARD_ACTIONS = {
  UPDATE_CARD_VERIFICATION_CODE: 'UPDATE_CARD_VERIFICATION_CODE',
  CHANGE_BILLING_ADDRESS: 'CHANGE_BILLING_ADDRESS',
  GET_FUNDING_OPTIONS: 'GET_FUNDING_OPTIONS',
  CLOSE: 'CLOSE',
  SHOW_PIN: 'SHOW_PIN',
  SET_PIN: 'SET_PIN',
  SHOW_CARD: 'SHOW_CARD',
  REACTIVATE: 'REACTIVATE',
  DEACTIVATE: 'DEACTIVATE',
  APPLICATIONS: 'APPLICATIONS',
}

export const OPERATIONS = {
  APPLICATIONS: 'APPLICATIONS',
  REPORT_CARD_LOST: 'REPORT_CARD_LOST',
  REISSUE: 'REISSUE',
  PINS: 'PINS',
  DEACTIVATE: 'DEACTIVATE',
  FUNDING_OPTIONS: 'FUNDING_OPTIONS',
  SHOW_PIN: 'SHOW_PIN',
  CLOSE: 'CLOSE',
}

export const FORM_FACTORS = {
  TOKEN: 'TOKEN',
  EMV: 'EMV',
}

export const SUB_OPERATIONS = {
  // APPLICATIONS
  ACTIVATE: 'ACTIVATE',

  // REPORT_CARD_LOST
  REPLACE: 'REPLACE',

  // REPORT_CARD_LOST for Digital Card
  REPORT_DIGITAL_CARD_LOST: 'REPORT_DIGITAL_CARD_LOST',

  // REISSUE for Digital Card (Get Physical Card)
  CONVERT_FORM_FACTOR: 'CONVERT_FORM_FACTOR',
  CONVERT_FORM_FACTOR_WITH_FEE: 'CONVERT_FORM_FACTOR_WITH_FEE',

  // REISSUE
  WORN: 'WORN',

  // UNLOCK
  REACTIVATE: 'REACTIVATE',
  DEACTIVATE: 'DEACTIVATE',

  GET_FUNDING_OPTIONS: 'GET_FUNDING_OPTIONS',
  SHOW_PIN: 'SHOW_PIN',
  SET_PIN: 'SET_PIN',
  CLOSE: 'CLOSE',
}

// Deprecated: To use ERROR_NAMES instad
export const errorNames = {
  // Status Code 422
  UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
  // Status Code 400
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  // Status Code 403
  FORBIDDEN: 'FORBIDDEN',
}

export const ERROR_NAMES = errorNames

export const EVALUATE_FUNDING_OPTIONS = {
  STATUS: {
    ELIGIBLE: 'ELIGIBLE',
    CONTINGENCY: 'CONTINGENCY',
    // Below FUNDING_OPTIONS Status Codes yet to be handled.
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    INELIGIBLE: 'INELIGIBLE',
  },
  CONTINGENCY_CODE: {
    NEGATIVE_BALANCE_DECLINE: 'NEGATIVE_BALANCE_DECLINE',
    RISK_DECLINE: 'RISK_DECLINE',
    RISK_STEPUP: 'RISK_STEPUP',
    INVALID_FUNDING_PREFERENCE: 'INVALID_FUNDING_PREFERENCE',
    FUNDING_SOURCES_UNAVAILABLE: 'FUNDING_SOURCES_UNAVAILABLE',
    // Below CONTINGENCY_CODE yet to be handled.
    INVALID_ACCOUNT_STATE: 'INVALID_ACCOUNT_STATE',
    EXTERNAL_REDIRECT: 'EXTERNAL_REDIRECT',
    ACCESS_INSTRUMENTS_UNAVAILABLE: 'ACCESS_INSTRUMENTS_UNAVAILABLE',
  },
  FUNDING_SOURCES: {
    STATUS: {
      ELIGIBLE: 'ELIGIBLE',
      CONTINGENCY: 'CONTINGENCY',
    },
    CONTINGENCY_TYPE: {
      INSTRUMENT_PREAUTHORIZATION: 'INSTRUMENT_PREAUTHORIZATION',
      OPEN_BANKING_CONSENT_REQUIRED: 'CONSENT_CONTINGENCY',
    },
    CONTINGENCY_HANDLE_TYPE: {
      RESOLVE_CONTINGENCY: 'RESOLVE_CONTINGENCY',
      REDIRECT: 'REDIRECT',
    },
  },
}

export const RESOLVE_FUNDING_OPTIONS_CONTINGENCY = {
  STATUS: {
    SUCCESS: 'SUCCESS',
    CONTINGENCY: 'CONTINGENCY',
    DENIED: 'DENIED',
  },
  CONTINGENCY_TYPE: {
    UPDATE_INSTRUMENT: 'UPDATE_INSTRUMENT',
  },
  CONTINGENCY_HANDLE_TYPE: {
    REDIRECT: 'REDIRECT',
  },
}

export const SUPPORTED_FLOW_FEATURES = {
  INSTRUMENT_PREAUTHORIZATION: 'INSTRUMENT_PREAUTHORIZATION',
  OPEN_BANKING_CONSENT_REQUIRED: 'CONSENT_CONTINGENCY',
  SHOW_UNCONFIRMED_UNAUTHORIZED_BANKS: 'SHOW_UNCONFIRMED_UNAUTHORIZED_BANKS',
}

export const EVALUATION_CONTEXT = {
  [SUPPORTED_FLOW_FEATURES.INSTRUMENT_PREAUTHORIZATION]: {
    type: 'FLOW_CAN_HANDLE_INSTRUMENT_PREAUTHORIZATION',
    value: 'true',
  },
  [SUPPORTED_FLOW_FEATURES.OPEN_BANKING_CONSENT_REQUIRED]: {
    type: 'FLOW_CAN_HANDLE_REAL_TIME_BALANCE_DECISION',
    value: 'true',
  },
  [SUPPORTED_FLOW_FEATURES.SHOW_UNCONFIRMED_UNAUTHORIZED_BANKS]: {
    type: 'FLOW_CAN_HANDLE_UNCONFIRMED_UNAUTHORIZED_BANKS',
    value: 'true',
  },
}

export function hasOpenBankingContingency({ status, contingencyDetails = {} }) {
  const { type = '', handleType = '', link = {} } = contingencyDetails
  const { href = '' } = link
  const { STATUS, CONTINGENCY_TYPE, CONTINGENCY_HANDLE_TYPE } =
    EVALUATE_FUNDING_OPTIONS.FUNDING_SOURCES
  return (
    status === STATUS.CONTINGENCY &&
    type === CONTINGENCY_TYPE.OPEN_BANKING_CONSENT_REQUIRED &&
    handleType === CONTINGENCY_HANDLE_TYPE.REDIRECT &&
    href !== ''
  )
}

export function hasContingencyResolverFlowQuery(contingencyDetails = {}, flow) {
  const flowQuery = contingencyDetails.contingencyResolverFlowQuery
  return !!flow && flowQuery && !!flowQuery[flow]
}

export const getEvaluationContext = (supportedFlowFeatures = []) => {
  const evaluationContext = supportedFlowFeatures.reduce((filtered, supportedFlowFeature) => {
    if (supportedFlowFeature && EVALUATION_CONTEXT[supportedFlowFeature]) {
      filtered.push(EVALUATION_CONTEXT[supportedFlowFeature])
    }
    return filtered
  }, [])

  if (evaluationContext.length > 0) {
    return evaluationContext
  }

  return null
}

/**
 * Client-only status & handle type for a Funding Instrument, derived from a combination of
 * the FI status & handle type in the evaluate-funding-options response and
 * the FI status & handle type from FI contingency resolvers, which include:
 * - the resolve-funding-options-contingency API
 * - contingency-resolver flows that the user is redirected to
 *
 * the FI handle type is only present when the FI has CONTINGENCY status
 */
export const FUNDING_SOURCE = {
  STATUS: {
    ELIGIBLE: 'ELIGIBLE',
    CONTINGENCY: 'CONTINGENCY',
    DENIED: RESOLVE_FUNDING_OPTIONS_CONTINGENCY.STATUS.DENIED,
  },
  CONTINGENCY_HANDLE_TYPE: {
    REDIRECT: 'REDIRECT',
  },
}

export const RESOLVED_CONTINGENCY_TYPE = {
  INSTRUMENT_PREAUTHORIZATION:
    EVALUATE_FUNDING_OPTIONS.FUNDING_SOURCES.CONTINGENCY_TYPE.INSTRUMENT_PREAUTHORIZATION,
  OPEN_BANKING_CONSENT_REQUIRED:
    EVALUATE_FUNDING_OPTIONS.FUNDING_SOURCES.CONTINGENCY_TYPE.OPEN_BANKING_CONSENT_REQUIRED,
  UPDATE_INSTRUMENT: RESOLVE_FUNDING_OPTIONS_CONTINGENCY.CONTINGENCY_TYPE.UPDATE_INSTRUMENT,
}

/**
 * This maps Web and/or Service level contingency names to FPTI specific contingency names according to the FPTI contract
 */
export const FPTI_FI_CONTINGENCY_TYPE_MAP = {
  [EVALUATE_FUNDING_OPTIONS.FUNDING_SOURCES.CONTINGENCY_TYPE.OPEN_BANKING_CONSENT_REQUIRED]:
    'OPEN_BANKING',
}

export const hasSystemResolvableContingency = ({ status = '', contingencyDetails = {} }) => {
  const {
    STATUS: { CONTINGENCY },
    CONTINGENCY_HANDLE_TYPE: { RESOLVE_CONTINGENCY },
  } = EVALUATE_FUNDING_OPTIONS.FUNDING_SOURCES
  return status === CONTINGENCY && contingencyDetails.handleType === RESOLVE_CONTINGENCY
}

export const SHIPMENT_STATUS = {
  NOT_SHIPPED: 'NOT_SHIPPED',
  ON_THE_WAY: 'ON_THE_WAY',
  ARRIVED: 'ARRIVED',
}

export const CARD_BRANDS = {
  VISA: 'VISA',
  MASTER_CARD: 'MASTER_CARD',
}

export const PRODUCT_NAME_VARIATION_TYPES = {
  ALIAS: 'alias',
  SYSTEM: 'system',
  USER_FRIENDLY: 'userFriendly',
}

const { ALIAS, SYSTEM, USER_FRIENDLY } = PRODUCT_NAME_VARIATION_TYPES

export const getProductDetailByPropertyName = (propertyValue = '', propertyName = SYSTEM) => {
  const product = Object.keys(PRODUCT_NAME_VARIATIONS).find(
    (productKey) => PRODUCT_NAME_VARIATIONS[productKey][propertyName] === propertyValue,
  )

  return PRODUCT_NAME_VARIATIONS[product]
}

export const getProductSystemNameByAlias = (productName) => {
  return getProductDetailByPropertyName(productName, ALIAS)?.system || productName
}

export const getProductSystemNameByUserFriendlyName = (userFriendlyName) => {
  return getProductDetailByPropertyName(userFriendlyName, USER_FRIENDLY)?.system || userFriendlyName
}

export const isCardActive = (card) => {
  return card?.lifecycleState === CARD_LIFECYCLE_STATE.ACTIVE
}

export const isCardNotShipped = (shipmentStatus = '') => {
  return shipmentStatus === SHIPMENT_STATUS.NOT_SHIPPED
}

export const isCardOnTheWay = (shipmentStatus = '') => {
  return shipmentStatus === SHIPMENT_STATUS.ON_THE_WAY
}

export const isCardArrived = (shipmentStatus = '') => {
  return shipmentStatus === SHIPMENT_STATUS.ARRIVED
}

export const isCardShipped = (shipmentStatus = '') => {
  return isCardOnTheWay(shipmentStatus) || isCardArrived(shipmentStatus)
}

const getFormFactorValue = (cardDetails) => {
  const { formFactor = '' } = cardDetails?.additionalDetails || {}
  return formFactor
}

export const isTokenFormFactor = (cardDetails) => {
  return getFormFactorValue(cardDetails) === FORM_FACTORS.TOKEN
}

export const isEMVFormFactor = (cardDetails) => {
  return getFormFactorValue(cardDetails) === FORM_FACTORS.EMV
}

export const isVirtualCard = (cardDetails) => {
  const { lifecycleState } = cardDetails || {}
  const { REISSUED } = CARD_LIFECYCLE_STATE
  return isTokenFormFactor(cardDetails) && lifecycleState === REISSUED
}

export const isPendingActiveCard = (cardDetails = {}) => {
  const { lifecycleState } = cardDetails || {}
  const { PENDING_ACTIVE } = CARD_LIFECYCLE_STATE
  return lifecycleState === PENDING_ACTIVE
}
export const APPLICATION_STATE = {
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
}

export const APPLICATION_STATES_WITHOUT_APPROVED = Object.values(APPLICATION_STATE).filter(
  (state) => state !== APPLICATION_STATE.APPROVED,
)

export const CARD_PIN_STATUS = {
  UNSET: 'UNSET',
  SET: 'SET',
}

export const CARD_PIN_ORIGIN = {
  USER: 'USER',
  SYSTEM: 'SYSTEM',
}

export const CARD_ACTIVATION_ERROR_CODES = {
  INVALID_CVV: 'INVALID_CVV',
  MISMATCHED_CVV: 'MISMATCHED_CVV',
}

export const CAPABILITIES = {
  OFFLINE_PIN: 'OFFLINE_PIN',
}

export const PRICING_DETAIL_TYPES = {
  CARD_ISSUANCE_FEE_PAYMENT: 'CARD_ISSUANCE_FEE_PAYMENT',
  CARD_ATM_WITHDRAWAL_FEE: 'CARD_ATM_WITHDRAWAL_FEE',
}

// TODO - MB: The REPLACE_CARD_REASONS declared on client/src/constants/card.js should be removed and
// use this one that can be imported from client and server folders.
export const REPLACE_CARD_REASONS = {
  // Card lost or stolen
  LOST_OR_STOLEN: 'LOST_OR_STOLEN',
  // Card damaged
  DAMAGED: 'DAMAGED',
  // Request physical card for digital only card
  GET_PHYSICAL_CARD: 'GET_PHYSICAL_CARD',
}
